export default __webpack_public_path__ + "static/media/MauiCard1.cdbf9055.png";